const Checked = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.5" cy="12.5" r="12.5" fill="#39CA74" />
    <path d="M4 11L11 18L21 8" stroke="white" strokeWidth="2" />
  </svg>
);

export default Checked;
